export const orderType = [
  "Geodata Archive",
  "Standard Order"
];

export const resolution = [
  "0.1m - 0.5m (Ultra high)",
  "0.5m - 1m (Very high)",
  "1m - 5m (High)",
  "5m - 25m (Medium)",
  "25m - 100m (Low)",
  "100m - 1km (Coarse)",
];

export const priorityLane = [
  "Normal",
  "High",
  "ASAP"
];

export const RecurringOrder = [
  "Daily",
  "Every week",
  "Never"
];

export const imagingSpectrum = [
  {
    label: 'MSI',
    value: 'Spectral',
  },
  {
    label: 'HSI',
    value: 'Hyper-S',
  },
  {
    label: 'SAR',
    value: 'SAR',
  },
];


export const coverageWindowValueType = [
  'days',
  'weeks',
  'months',
];

export const faultToleranceOptions = [
  "ISL",
  "Ground Link"
];

export const recurringType = [
  {
    label: 'Every Day',
    value: 'everyDay'
  },
  {
    label: 'Every Week',
    value: 'everyWeek'
  },
  {
    label: 'Every Month',
    value: 'everyMonth'
  },
];

// export const recurringOptions = [
//     "One time",
//     "More than one-time"
// ];

export const ORDER_DETAILS_KEYS = [
  'platform',
  'eo:cloud_cover',
  'created'
];

export const ORDER_DETAILS_KEYS_LABEL = [
  {
    label: 'Platform',
    value: 'platform',
  },
  {
    label: 'Cloud Cover',
    value: 'eo:cloud_cover',
  },
  {
    label: 'Creation Date',
    value: 'created',
  },
];

export const ASSET_OPTIONS = [
  {
    id: 1,
    label: 'Blue'
  },
  {
    id: 2,
    label: 'Geodata Preview'
  },
  {
    id: 3,
    label: 'Reduced Resolution'
  },
  {
    id: 4,
    label: 'Thumbnail'
  },
];

export const PROVIDER_OPTIONS = [
  'MAXAR',
  'PLANET',
  'ANTARIS',
  'SENTINEL',
  'LANDSAT',
  'BHOONIDHI'
]

export const ORDER_STATUS = {
  EXECUTED: 'executed',
  PENDING: 'pending',
  CURRENT: 'current'
}

export const propertyOptions = [
  { propertyID: "status", name: "Status" },
  { propertyID: "providertype", name: "Provider Type" }
];

export const equalityOptions = [
  { propertyID: "equals", name: "Is Equals" },
  { propertyID: "notEquals", name: "Is Not Equals" }
];

export const statusOptions = [
  { propertyID: "Draft", name: "Draft" },
  { propertyID: "Pending", name: "Pending" },
  { propertyID: "Submitted", name: "Submitted" },
  { propertyID: "Accepted", name: "Accepted" },
  { propertyID: "Active", name: "Active" },
  { propertyID: "DataReady", name: "Data Ready" },
  { propertyID: "Success", name: "Success" },
  { propertyID: "Failed", name: "Failed" },
];

export const providerTypeOptions = [
  { propertyID: "Antaris", name: "Antaris" },
  { propertyID: "StrataTest", name: "Strata" },
];

export const analysisOptions = [
  { propertyID: "bunker_events", name: "Marine Analysis" },
  { propertyID: "bunker_analysis", name: "Land Analysis" },
];

export const RESIZE_OPTIONS = [
  { pxName: "256px", value: 256 },
  { pxName: "512px", value: 512 },
  { pxName: "1024px", value: 1024 },
  { pxName: "2048px", value: 2048 },
];